import { NegotiationDetail, NegotiationType } from 'api'
import { isNil } from 'lodash'
import React from 'react'
import { TimeRenderer, TimeRendererProps } from '../TimeRenderer'
import { StatusTimerContainer } from './NegotiationActionRendererStyles'

export const NegotiationTimeRendererComponent: React.FC<TimeRendererProps<NegotiationDetail>> = props => {
  const {
    node: { data }
  } = props

  if (isNil(data)) {
    return null
  }

  const shouldShowStatusTimer = data.negotiation.negotiationType !== NegotiationType.ONE_CANCELS_OTHERS_SUMMARY

  return (
    <StatusTimerContainer data-test-id="status-timer-container">
      {shouldShowStatusTimer && <TimeRenderer {...props} />}
    </StatusTimerContainer>
  )
}
